module.exports = __webpack_public_path__ + "assets/img/chip.ddfbaad7.svg";